import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=6da215e8&scoped=true&"
import script from "./Recap.ts?vue&type=script&lang=ts&"
export * from "./Recap.ts?vue&type=script&lang=ts&"
import style0 from "./Recap.scss?vue&type=style&index=0&id=6da215e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da215e8",
  null
  
)

export default component.exports